import { z } from 'zod';

/** GET /v1/positions — элемент справочника должностей. */
export const positionSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullable().optional(),
  is_active: z.boolean(),
});

export type Position = z.infer<typeof positionSchema>;

export const positionsResponseSchema = z.object({
  items: z.array(positionSchema),
  next_page_token: z.string().nullable().optional(),
});

export type PositionsResponse = z.infer<typeof positionsResponseSchema>;
